import { WBCheckbox } from '@admiin-com/ds-web';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AutoCompleteLookupV2 from '../../AutoCompleteLookup/AutoCompleteLookupV2';
import React from 'react';
import { isEntityOrContact } from '../../../helpers/entities';
import { useFromToTypeFromTaskDirection } from '../../../pages/TaskCreation/useFromToTypeFromTaskDirection';
import useSelectedFirm from '../../../hooks/useSelectedFirm/useSelectedFirm';
import { Bill } from '../../PayBill/PayBillCreateForm';
import { useTaskCreationContext } from '../../../features/providers/TaskCreationProvider/useTaskCreationContext';
export const SignFromTo = ({ scannedTax }: { scannedTax: Bill | null }) => {
  const { control, watch, setValue } = useFormContext();
  const { t } = useTranslation();
  const { taskDirection, task, taskType, client, isTaxBinding } =
    useTaskCreationContext();
  const isTaxType = taskType === 'tax';
  const { selectedFirm: firm } = useSelectedFirm();

  const inputs = React.useMemo(
    () => ({
      from: {
        label: t('from', { ns: 'taskbox' }),
        name: 'from' as const,
        type: 'text',
        defaultValue: client || isTaxType ? firm : null,

        placeholder:
          taskDirection === 'SENDING'
            ? t('entitySearchPlaceholder', { ns: 'taskbox' })
            : t('contactSearchPlaceholder', { ns: 'taskbox' }),
        rules: { required: t('fromRequired', { ns: 'taskbox' }) },
      },
      to: {
        label: t('to', { ns: 'taskbox' }),
        name: 'to' as const,
        type: 'text',
        defaultValue: isTaxType ? client : null,
        placeholder:
          taskDirection === 'RECEIVING'
            ? t('entitySearchPlaceholder', { ns: 'taskbox' })
            : t('contactSearchPlaceholder', { ns: 'taskbox' }),
        rules: { required: t('toRequired', { ns: 'taskbox' }) },
      },
    }),
    [t, isTaxType, firm, taskDirection, client]
  );

  const { fromType, toType } = useFromToTypeFromTaskDirection();

  const from = useWatch({ name: 'from', control });
  const entityId = watch('to.id');

  const { selectedFirm } = useSelectedFirm();

  React.useEffect(() => {
    if (isTaxType || client) {
      setValue('from', selectedFirm);
    }
  }, [isTaxType, selectedFirm, setValue, client]);

  const clientGroupCode = client?.clientGroupCode;

  return (
    <>
      <Controller
        control={control}
        name={inputs.from.name}
        rules={inputs.from.rules}
        defaultValue={inputs.from.defaultValue}
        render={({ field, formState: { errors } }) =>
          isTaxType || taskDirection === 'SENDING' ? (
            <div />
          ) : (
            <AutoCompleteLookupV2
              {...field}
              noPopupIcon
              label={inputs.from.label}
              placeholder={inputs.from.placeholder}
              entityId={entityId}
              type={fromType}
              helperText={(errors[field.name]?.message as string) ?? ''}
              disabled={!!task || isTaxType}
              error={!!errors[field.name]}
              additonalOptions={client ? [firm] : undefined}
            />
          )
        }
      />
      {taskDirection === 'RECEIVING' &&
        isEntityOrContact(from) === 'CONTACT' && (
          <Controller
            control={control}
            name={'sendCopyToContact'}
            defaultValue={true}
            render={({ field }) => (
              <WBCheckbox
                {...field}
                checked={field.value}
                label={t('sendCopyToContact', { ns: 'taskbox' })}
              />
            )}
          />
        )}
      {/* {taskDirection === 'RECEIVING' && ( */}
      <Controller
        control={control}
        name={inputs.to.name}
        rules={inputs.to.rules}
        defaultValue={inputs.to.defaultValue}
        render={({ field, formState: { errors } }) =>
          isTaxType || taskDirection === 'RECEIVING' ? (
            <div />
          ) : (
            <AutoCompleteLookupV2
              {...field}
              noPopupIcon
              label={inputs.to.label}
              placeholder={inputs.to.placeholder}
              clientGroupCode={clientGroupCode}
              type={toType}
              client={client}
              helperText={(errors[field.name]?.message as string) ?? ''}
              disabled={!!task || (isTaxType && !isTaxBinding)}
              error={!!errors[field.name]}
            />
          )
        }
      />
      {/* )} */}
    </>
  );
};
